import { createTheme, colors } from "@mui/material";
import * as themeHelper from "../../Application/Helper/ThemeHelper";

import { useEventListener } from "pages/Hooks/useEventListener";
import { useEffect, useState } from "react";
import Languages from "pages/config/Languages";
import { useTranslation } from "react-i18next";
import { LANGUAGE_CHANGE } from "pages/constants/EventKeys";
import { getCurrentUserData } from "Application/User/UserService";
import { getCurrentLanguage } from "pages/Utils/LanguageHelper";

export const themeColors = {
  [themeHelper.ADMIN]: colors.red,
  [themeHelper.MANAGER]: colors.deepOrange,
  [themeHelper.FINANCIAL]: colors.green,
  [themeHelper.CREDITOR]: colors.indigo,
  [themeHelper.DEBTOR]: colors.blue,
};

export default function useCustomTheme() {
  const themeKey = getCurrentUserData().getUserType() ?? themeHelper.CREDITOR;
  const selectedColor = themeColors[themeKey];

  const currentLocaleFromStorage  = getCurrentLanguage();

  const { i18n } = useTranslation();
  const [currentLocale, setCurrentLocale] = useState(currentLocaleFromStorage);

  useEffect(() => handleLanguageChange(currentLocaleFromStorage), []);

  function handleLanguageChange(currentLanguage) {
    setCurrentLocale(currentLanguage);
    setTimeout(() => i18n.changeLanguage(currentLanguage), 0);
  }

  useEventListener(LANGUAGE_CHANGE, (lang) => handleLanguageChange(lang));
  const themeToApply = createTheme(
    {
      ...commonThemeOptions(selectedColor),
      palette: {
        primary: {
          main: selectedColor[600],
        },
        secondary: {
          main: selectedColor[400],
        },
      },
    },
    ...Languages[currentLocale].locales
  );

  return themeToApply;
}

const commonThemeOptions = (selectedColor) => ({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: selectedColor[300] + " transparent",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: selectedColor[300],
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: selectedColor[900],
          },
          "&::-webkit-scrollbar-thumb:active": {
            backgroundColor: selectedColor[900],
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          "&:not(.Mui-error).Mui-focused": {
            color: "blue",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            "&:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
              borderColor: "blue",
            },
          },
        },
      },
    },
  },
});
